<style lang="sass">
.pinhigh-table-wrapper
  font-size: 0.8rem
  .pinhigh-table
    display: flex
    flex-direction: column
    .pinhigh-table-header
      display: flex
      flex-direction: row
      justify-content: space-around
      align-items: center
      border-bottom: 1px solid #e0e0e0
      padding: 0.5rem 0
      height: 31px
      > *
        flex: 1
        min-width: 0
        display: flex
        align-items: center
        padding: 0 0.5rem
        font-weight: 700
    >:nth-child(n + 1)
      display: flex
      flex-direction: row
      justify-content: space-around
      align-items: center
      border-bottom: 1px solid #e0e0e0
      padding: 0.5rem 0
      height: 31px
      > *
        flex: 1
        min-width: 0
        display: flex
        align-items: center
        padding: 0 0.5rem
.pinhigh-table-wrapper >.pinhigh-table.pinhigh-table-justified >* >:last-child
  justify-content: flex-end
</style>
<template>
  <div>
    <div class="pinhigh-table-wrapper">
      <div class="pinhigh-table" :class="{'pinhigh-table-justified': justified}">
        <div class="pinhigh-table-header" v-if="headers.length && headerEnabled">
          <slot name="headers" :headers="headers">
            <div class="pinhigh-table-header-column" v-for="header in headers">
              {{header}}
            </div>
          </slot>
        </div>
        <slot name="row" :row="row" :index="index" v-for="(row, index) in rows">
          <div>
            <div v-for="column in row">{{column}}</div>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PinhighTable',
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    headerEnabled: {
      type: Boolean,
      default: true
    },
    rows: {
      type: Array,
      default: []
    },
    justified: {
      type: Boolean,
      default: false
    }
  }
}
</script>
